module.exports = __webpack_public_path__ + "img/questionnaire.a224edf7.png";